import { Component, Element, h, Host, Prop } from '@stencil/core';
import { open_in_new } from 'pn-design-assets/pn-assets/icons.js';

import { URLS } from './urls';
import { translations } from './translations';

import { SE, NO, en, awaitTopbar } from '@/globals/helpers';
import { PnMarkets, PnLanguages } from '@/globals/types';

/**
 * The default market and language is SE/en.
 *
 * Make sure you set the market **and** language prop.
 * Example: Setting the `language` prop `da` will not display anything, as `da` does not exist on the `SE` market.
 */
@Component({
  tag: 'pn-footer',
  styleUrl: 'pn-footer.scss',
})
export class PnFooter {
  @Element() hostElement: HTMLElement;

  /** Set the market for the footer. */
  @Prop() market?: PnMarkets = null;
  /** Set the language for the footer. */
  @Prop() language?: PnLanguages = null;

  async componentWillLoad() {
    if (this.market && this.language) return;
    await awaitTopbar(this.hostElement);
  }

  getLink(name: string): string {
    return URLS?.[this.market || SE]?.[name]?.[this.language || en];
  }
  getText(name: string): string {
    if (name === 'domain') return this.getLink(name)?.replace('https://www.', '');
    return translations?.[name]?.[this.language];
  }

  renderLink(name: string): HTMLElement {
    const url = this.getLink(name);
    const text = this.getText(name);
    if (url && text) {
      return <pn-text-link label={text} target="_blank" rel="noopener noreferrer" href={url} icon={open_in_new} />;
    }
  }

  render() {
    return (
      <Host>
        <div class="pn-footer-row">
          <p>{this.getText('questions')}</p>
          {this.renderLink('contact')}
        </div>
        <div class="pn-footer-row">
          {this.market !== NO && this.renderLink('terms')}
          {this.renderLink('privacy')}
          {this.renderLink('cookies')}
        </div>
        <div class="pn-footer-row">
          <p>{this.getText('info')}</p>
          {this.renderLink('domain')}
        </div>
      </Host>
    );
  }
}
